import styled from 'styled-components'

export const SectionTitleContainer = styled.div`
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  margin-bottom: 1rem;
`
